import React from 'react';

const Footer = () => {
  return (
    <footer style={styles.footer}>
    <hr style={styles.hr} />
    <div style={styles.linkWrapper}>
      <a href="https://www.johndorys.co.uk/" style={styles.link}>
        John Dory's
      </a>
      <a href="https://www.johndorys.co.uk/order" style={styles.link}>
        Order Online
      </a>
    </div>
  </footer>
  );
};

const styles = {
  footer: {
    padding: "10px 0",
    textAlign: "center",
  },
  hr: {
    margin: "10px 0",
  },
  linkWrapper: {
    display: "flex",
    justifyContent: "center",
    gap: "20px", // Space between links
  },
  link: {
    color: "#000", // Adjust link color as needed
    textDecoration: "none",
    fontSize: "16px",
  },
};

export default Footer;
